import { render, staticRenderFns } from "./pointhistory.vue?vue&type=template&id=26cf457d&scoped=true"
import script from "./pointhistory.vue?vue&type=script&lang=js"
export * from "./pointhistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26cf457d",
  null
  
)

export default component.exports